export enum CrmTask {
    AksDays = 'crm-generate-ankorstore-days-email',
    NewProducts = 'crm-generate-new-products-email',
    VoucherFees = 'crm-generate-voucher-fees-email',
    ActivateRetailer = 'crm-generate-activate-retailer-email',
    ReactivateRetailer = 'crm-generate-reactivate-retailer-email',
}

type AnkorAgentModel = 'gpt-4.1-nano' | 'gpt-4.1-mini' | 'gpt-4o';

export interface RunCrmTaskPayload {
    task: CrmTask;
    language: string;
    // Can be any shape, as long as it is JSON serializable and accurately describes a list of products
    products: object;
    additionalInstructions?: string;
    catalogueLink: string;
    discount: number;
    retailerName?: string;
    targetCountries: string[];
    freeDeliveryThreshold?: string;
    messagesURL?: string;
}

export interface AnkorAgentTaskResponse {
    uuid: string;
    task: CrmTask;
    model: AnkorAgentModel;
    input: string;
    memory: string;
    output: string;
    duration: number;
    executed: boolean;
    success: boolean;
    async: boolean;
    created_at: string;
    executed_at: string;
}